import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@mui/material';
import BaseField from './BaseField';

/**
 * NumberField component for workflow forms.
 * Extends the BaseField with numeric input functionality.
 */
const NumberField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
  className,
  min,
  max,
  step,
  inputProps,
  ...rest
}) => {
  // Handle change to ensure only numbers are entered
  const handleChange = (e) => {
    const { value } = e.target;
    // Allow empty values, numbers, and decimal points
    if (value === '' || /^-?\d*\.?\d*$/.test(value)) {
      onChange(e);
    }
  };

  return (
    <BaseField
      id={id}
      name={name}
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
    >
      <MuiTextField
        id={id}
        name={name}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        error={Boolean(error)}
        type="number"
        size="small"
        inputProps={{
          min,
          max,
          step,
          ...inputProps,
        }}
        {...rest}
      />
    </BaseField>
  );
};

NumberField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  inputProps: PropTypes.object,
};

NumberField.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: true,
  value: '',
  step: 1,
};

export default NumberField;
